var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Define_Plan',{on:{"update_plan":_vm.respond_to_updated_plan}}),(_vm.plan !== null)?_c('View_Plan_as_SVG',{attrs:{"title":_vm.plan.title,"habits":_vm.plan.habits,"goals":_vm.plan.goals}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }